import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';

const TrialBanner = () => {
  const [visible, setVisible] = useState(false);
  const [daysRemaining, setDaysRemaining] = useState(0);
  const navigate = useNavigate();
  const { user, isAuthenticated } = useAuth();

  useEffect(() => {
    if (!isAuthenticated || !user) {
      setVisible(false);
      return;
    }
    if (user.subscriptionStatus === 'active') {
      setVisible(false);
      return;
    }
    // Calculate trial end from trialEndDate or createdAt + 14 days
    let endDate = null;
    if (user.trialEndDate) {
      endDate = new Date(user.trialEndDate);
    } else if (user.createdAt) {
      endDate = new Date(new Date(user.createdAt).getTime() + 14 * 24 * 60 * 60 * 1000);
    }
    if (endDate) {
      const now = new Date();
      const diffMs = endDate - now;
      const diffDays = Math.ceil(diffMs / (1000 * 60 * 60 * 24));
      if (diffDays > 0 && diffDays <= 14) {
        setDaysRemaining(diffDays);
        setVisible(true);
      } else {
        setVisible(false);
      }
    }
  }, [user, isAuthenticated]);

  if (!visible) return null;

  const urgentStyle = daysRemaining <= 3;

  return (
    <div className={`w-full px-4 py-2 text-center text-sm font-medium flex items-center justify-center gap-3 ${
      urgentStyle
        ? 'bg-red-600 text-white'
        : 'bg-yellow-400 text-yellow-900'
    }`}>
      <span>
        {urgentStyle ? '\u26A0\uFE0F ' : ''}
        Free trial: {daysRemaining} day{daysRemaining !== 1 ? 's' : ''} remaining
      </span>
      <button
        onClick={() => navigate('/pricing')}
        className={`px-3 py-1 rounded text-xs font-bold transition ${
          urgentStyle
            ? 'bg-white text-red-600 hover:bg-red-50'
            : 'bg-yellow-900 text-yellow-100 hover:bg-yellow-800'
        }`}
      >
        Upgrade Now
      </button>
      <button
        onClick={() => setVisible(false)}
        className={`ml-2 text-lg leading-none ${
          urgentStyle ? 'text-red-200 hover:text-white' : 'text-yellow-700 hover:text-yellow-900'
        }`}
        aria-label="Dismiss"
      >
        
      </button>
    </div>
  );
};

export default TrialBanner;
